import Chip from './chip'

export const AmuiChip = Chip

export default Vue => Vue.component(Chip.name, Chip)
